import { useSearchParams } from "react-router-dom";
import { useGetMachineIdTranslator } from "../../../hooks/useGetMachineIdTranslator";

import styled from "styled-components";
import { useGetOrdersByDateAndAsset } from "./utils/useGetOrdersByAsset";
import MIOrderCard from "./MIOrderCard";

const ButtonContainer = styled.div`
  display: flex;
  height: 100%;
  padding: 2rem;
  flex-direction: column;
  align-items: center;
`;

const AssetButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-grey-900);
  padding: 0.7em 1.7em;
  margin-top: 1.5rem;
  font-size: 1em;
  min-width: 28rem;
  width: auto;
  margin-left: 0.5em;
  white-space: nowrap;
  border-radius: 0.5em;
  background: var(--color-grey-0);
  border: 1px solid var(--color-grey-100);
  transition: all 0.3s;
  box-shadow: var(--shadow-btn);

  &:hover {
    background-color: var(--color-witron-blue);
  }
`;

const ButtonContent = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonAssetText = styled.div`
  font-size: 0.7em;
  color: var(--color-grey-600);
`;

const OrderList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  width: 100%;
  max-height: 90vh; /* Set maximum height for the container */
  overflow-y: auto; /* Enable vertical scrolling when content overflows */
  scrollbar-width: thin; /* For Firefox, thin scrollbar */
  scrollbar-color: var(--color-grey-300) var(--color-grey-50); /* For Firefox */

  /* For WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--color-grey-300);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--color-grey-50);
  }
`;

const OrderItem = styled.div`
  margin: 0.5rem;
  padding: 1rem;
  width: 80%;
  border: 1px solid var(--color-grey-300);
  border-radius: 0.5rem;
  background: var(--color-grey-50);
`;

function MIOrderHistory() {
  const [searchParams, setSearchParams] = useSearchParams();
  const machine = searchParams.get("m");
  const selectedAsset = searchParams.get("asset");

  const {
    data: machineData,
    isLoading: isMachineLoading,
    isError,
  } = useGetMachineIdTranslator({ machine });

  const { data: orders, isLoading: isOrdersLoading } =
    useGetOrdersByDateAndAsset(null, null, selectedAsset);

  const witoolAssets = (() => {
    if (machineData?.data?.length > 0 && !isMachineLoading) {
      try {
        return machineData.data[0]?.witoolId
          ? JSON.parse(machineData.data[0].witoolId)
          : [];
      } catch (error) {
        console.error("Invalid JSON string for witoolId:", error);
        return [];
      }
    }
    return [];
  })();

  const handleAssetClick = (assetId) => {
    setSearchParams({ view: "orders", m: machine, asset: assetId });
  };

  if (isMachineLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading machine data.</div>;

  return (
    <>
      {!selectedAsset ? (
        witoolAssets.length > 0 ? (
          <ButtonContainer>
            {witoolAssets.map((asset) => (
              <AssetButton
                key={asset.id}
                onClick={() => handleAssetClick(asset.id)}
              >
                <ButtonContent>
                  {asset.description || "Unnamed Asset"}{" "}
                  <ButtonAssetText>{asset.id}</ButtonAssetText>
                </ButtonContent>
              </AssetButton>
            ))}
          </ButtonContainer>
        ) : (
          <div>No WiTool assets found.</div>
        )
      ) : isOrdersLoading ? (
        <div>Loading orders for asset {selectedAsset}...</div>
      ) : (
        <OrderList>
          {orders.data?.length > 0 ? (
            orders.data.map((order, index) => (
              <OrderItem key={index}>
                <MIOrderCard order={order} />
              </OrderItem>
            ))
          ) : (
            <div>No orders found for asset {selectedAsset}.</div>
          )}
        </OrderList>
      )}
    </>
  );
}

export default MIOrderHistory;
